import type { TestRun } from "../../types";
import { useApiQuery } from "../use-api-query";

/**
 * Fetches test runs triggered during a specific Argus agent session
 * (up to 50, newest first).
 *
 * Since ARGUS_VERSION 0.10.3 qa-use subprocesses spawned by the agent
 * carry `X-Argus-Created-By: agent:<pi_session_id>` (injected per-session
 * by the gateway's bash `spawnHook`), which `be/api/vibe_qa_cli.py`
 * stamps onto `TestRun.created_by`. Filtering on that value yields
 * exactly the runs belonging to this agent session.
 */
export function useArgusAgentSessionTestRuns(agentSessionId: string | null): TestRun[] {
  const createdBy = agentSessionId ? `agent:${agentSessionId}` : "";
  const query = createdBy
    ? `/vibe-qa/tests-runs?limit=50&created_by=${encodeURIComponent(createdBy)}`
    : "";

  // The `/vibe-qa/tests-runs` endpoint returns a bare array, not an envelope.
  const { data } = useApiQuery<TestRun[]>(query, {
    enabled: Boolean(createdBy),
    refetchInterval: 5000,
  });

  return data ?? [];
}
